import React, { Component, Fragment } from 'react';
import { Switch, Route } from 'react-router-dom';
import './App.css';

import Header from './components/Header/Header';

import Landing from './pages/Landing/Landing';
import About from './pages/About/About';
import Pay from './pages/Pay/Pay';
import IT from './pages/IT/IT';
import Benefits from './pages/Benefits/Benefits';
import Communication from './pages/Communication/Communication';

class App extends Component {
	state = {
		className: 'header-down',
		didScroll: true,
		lastScrollTop: 0,
		contentNode: null
	};
	
	componentDidMount() {
		const contentNode = document.getElementById( 'Content' );
		if( contentNode ) {
			contentNode.addEventListener( 'scroll', this.handleScroll );
			this.setState({
				contentNode: contentNode
			});
		}
	}
	
	handleScroll = event => {
		const delta = 5;
		const headerHeight = document.getElementById( 'Header' ).offsetHeight;
		const st = this.state.contentNode.scrollTop;
		let headerClass = '';
		const contentHeight = Math.max(
			this.state.contentNode.scrollHeight,
			this.state.contentNode.offsetHeight,
			this.state.contentNode.clientHeight
		);
		
		if( Math.abs( this.state.lastScrollTop - st ) <= delta ) return;
		
		if( st > this.state.lastScrollTop && st > headerHeight ) {
			headerClass = 'header-up';
		}
		else {
			if( st < contentHeight ) {
				headerClass = 'header-down';
			}
		}
		
		this.setState({
			headerClass: headerClass,
			lastScrollTop: st
		});
	};
	
	render() {
		return (
			<Fragment>
				<Header className={ this.state.headerClass } />
				<Switch>
					<Route exact path='/' component={ Landing } />
					<Route exact path='/about-our-company' component={ About } />
					<Route exact path='/the-almighty-dollar' component={ Pay } />
					<Route exact path='/super-tech-support' component={ IT } />
					<Route exact path='/perks-for-the-people' component={ Benefits } />
					<Route exact path='/collaborate-and-listen' component={ Communication } />
				</Switch>
			</Fragment>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js